import { render, staticRenderFns } from "./PendingTherapyFeedback.vue?vue&type=template&id=1c460e69&scoped=true&"
import script from "./PendingTherapyFeedback.vue?vue&type=script&lang=js&"
export * from "./PendingTherapyFeedback.vue?vue&type=script&lang=js&"
import style0 from "./PendingTherapyFeedback.vue?vue&type=style&index=0&id=1c460e69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c460e69",
  null
  
)

export default component.exports